import React, { useContext } from "react";
import { ToastContainer } from "react-bootstrap";
import Toast from "react-bootstrap/Toast";
// import { useTranslation } from "react-i18next";
import { ToastContext } from "../../../Context/ToastContext";

function NotificationToast({
  position = "top-end",
  toastPosition = "top-end",
  autoHide = true,
  delay = 5000,
}) {
  const { toastMessages, removeToast } = useContext(ToastContext);

  return (
    <ToastContainer
      position={toastPosition}
      containerPosition={position}
      className="p-3 app-floating-toast-container"
      style={{
        maxWidth: "320px",
        minWidth: "300px",
        position: "fixed",
        zIndex: 999999,
      }}
    >
      {toastMessages.length > 0 &&
        toastMessages.map((toast, index) => (
          <Toast
            key={toast.id || `toast-${index}`}
            className="d-inline-block m-1 app-floating-toast"
            bg={toast.variant ? toast.variant.toLowerCase() : "success"}
            autohide={typeof toast?.autohide === "boolean" ? toast.autohide : autoHide}
            delay={toast?.delay || delay}
            animation={true}
            onClose={() => toast.id && removeToast(toast.id)}
            style={{ width: "320px" }}
          >
            <Toast.Header className="app-floating-toast-header">
              <strong className="me-auto text-white">
                {toast?.title || "Notification"}
              </strong>
            </Toast.Header>
            <Toast.Body className="bg-white app-floating-toast-body">
              {toast?.html ? (
                <p
                  className="mb-0"
                  dangerouslySetInnerHTML={{ __html: toast?.message || "No message" }}
                />
              ) : (
                <p className="mb-0">{toast?.message || "No message"}</p>
              )}
            </Toast.Body>
          </Toast>
        ))}
    </ToastContainer>
  );
}

export default NotificationToast;
